import { useNavigate, useRouter, useRouterState } from '@tanstack/react-router';

/**
 * GERİ NAVİGASYONU — "geldiğin yere dön".
 *
 * ⚠️ NEDEN GEREKLİ: iş detayının geri düğmesi SABİT olarak panoya gidiyordu
 *    (`onGeri={() => navigate({ to: '/' })}`) ve üstünde her zaman "Pano"
 *    yazıyordu. Arama ekranından bir işe girip geri basan kullanıcı aramasını
 *    kaybediyor, sonucu yeniden aratmak zorunda kalıyordu (kullanıcı bildirimi
 *    06.08.2026). Aynı şey kurulu iskele listesi ve günlük rapor için de
 *    geçerliydi — üç ayrı yerden gelinip tek bir yere dönülüyordu.
 *
 * ⚠️ ÇÖZÜM TARAYICI GEÇMİŞİ, elle tutulan bir "önceki sayfa" değişkeni DEĞİL.
 *    Geçmiş zaten doğru cevabı biliyor; paralel bir kayıt tutmak, kullanıcı
 *    tarayıcının kendi geri düğmesini kullandığı anda ikisini ayrıştırırdı.
 *
 * ⚠️ DOĞRUDAN GİRİŞTE GEÇMİŞ YOKTUR. Bildirimden, paylaşılan bir bağlantıdan
 *    ya da yenilenmiş bir sekmeden gelen kullanıcıda `history.back()` uygulamadan
 *    ÇIKARIRDI. O yüzden derinlik ölçülüyor ve geçmiş yoksa varsayılan yola
 *    gidiliyor.
 */

/**
 * Gezinme derinliği: uygulama içinde kaç adım atıldı.
 *
 * `window.history.length` GÜVENİLİR DEĞİL — sekmede daha önce başka siteler
 * gezildiyse şişer. TanStack kendi konum dizinini `state` içinde taşıyor;
 * yoksa 0 varsayıp güvenli tarafta kalıyoruz.
 */
function derinlik(state: unknown): number {
  const idx = (state as { __TSR_index?: number } | null | undefined)?.__TSR_index;
  return typeof idx === 'number' ? idx : 0;
}

export function useGeri(varsayilanEtiket: string, varsayilanYol = '/') {
  const router = useRouter();
  const navigate = useNavigate();
  const state = useRouterState({ select: (s) => s.location.state });

  const geriGidilebilir = derinlik(state) > 0;
  /*
   * ⚠️ ETİKET GENEL: "Geri". Gidilecek ekranın ADINI yazmak daha bilgilendirici
   *    olurdu ama o adı taşımanın tek yolu her gezinme çağrısına durum eklemek —
   *    beş ayrı çağrı yeri, ve biri unutulduğunda etiket YALAN söyler ("Pano"
   *    yazıp aramaya döner). Kullanıcının bildirdiği şikâyet zaten buydu.
   *    Geçmiş yoksa (bildirimden/paylaşılan bağlantıdan gelindi) çağıranın
   *    varsayılanı kullanılır; orada gerçekten oraya gidiliyor.
   */
  const etiket = geriGidilebilir ? 'Geri' : varsayilanEtiket;

  const geri = () => {
    if (geriGidilebilir) router.history.back();
    else void navigate({ to: varsayilanYol });
  };

  return { etiket, geri };
}
